// import content from './content';
import { useState } from 'react';
import Button from '@CS/components/Button';
// import { useTranslation } from '@CS/hooks';
import { Text, Title } from './PopUpDeleteMember.styles';
import type { CampaignState } from '@/redux/campaign/types';
import { type PopupProps, Popup, FADE_DURATION } from '@CS/components/Popups';

type PopUpDeleteMemberProps = PopupProps & {
  campaign: CampaignState;
  onDelete: () => void;
};

export const PopUpDeleteMember = ({
  campaign,
  onDelete,
  ...props
}: PopUpDeleteMemberProps) => {
  const onConfirm = () => setTimeout(onDelete, FADE_DURATION) && onCancel();
  // const { title, text, cancel, confirm } = useTranslation(content);

  const [closed, setClosed] = useState(false);
  const onCancel = () => setClosed(true);

  return (
    <Popup close={closed} {...props}>
      <Title>{campaign.translations.remove_title}</Title>
      <Text>{campaign.translations.remove_description}</Text>

      <Button onClick={onCancel} text={campaign.translations.remove_cta_cancel} margin="0 0 8px" />
      <Button onClick={onConfirm} text={campaign.translations.remove_cta_confirm} variant="secondary" />
    </Popup>
  );
};
